import React from 'react';
import PropTypes from 'prop-types';
//Mui components
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
//Graph
import { createData } from 'components/dialogs/performance/DialogPerformance.utils';
import { Line } from 'react-chartjs-2';
import 'chartjs-adapter-moment';
import translate from 'locales/i18n';

const options = {
    plugins: {
        legend: {
            display: true,
            fullWidth: true,
            position: 'bottom'
        }
    },
    maintainAspectRatio: false,
    scales: {
        x: {
            grid: {
                display: false
            },
            type: 'time',
            stacked: false
        },
        y: {
            grid: {
                display: false
            }
        }
    },
    tooltips: {
        intersect: false,
        mode: 'nearest'
    }
};

const DialogPerformanceGraph = ({ open, perfs, close }) => <Dialog open={open} onClose={close} maxWidth={false}>
    <DialogTitle>{translate.i18n('PERF_DIALOG_TITLE')}</DialogTitle>
    <DialogContent style={{ height: '700px', width: '1300px' }}>
        <Line data={{
            datasets: createData(perfs)
        }}
        options={options} />
    </DialogContent>
</Dialog>;

DialogPerformanceGraph.propTypes = {
    open: PropTypes.bool,
    close: PropTypes.func,
    perfs: PropTypes.array
};

export default DialogPerformanceGraph;
